import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";

function YesNoModal({
  children,
  handleYes,
  propShow,
  handleShowModal,
  title,
  YesText,
  NoText,
  YesDisabled,
}) {
  const { language } = useLanguage();
  const pageTitle = "YesNoModal";
  const [show, setShow] = useState(propShow);
  useEffect(() => {
    setShow(propShow);
  }, [propShow]);
  return (
    <Modal show={show} onHide={() => handleShowModal(false)}>
      {title ? (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      ) : (
        ""
      )}
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={() => handleShowModal(false)}>
          {NoText ? NoText : strings[pageTitle][language].no}
        </Button>
        <Button
          disabled={YesDisabled}
          variant="danger"
          onClick={() => {
            handleShowModal(false);
            handleYes();
          }}
        >
          {YesText ? YesText : strings[pageTitle][language].yes}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default YesNoModal;
